import { render, staticRenderFns } from "./PersonalizedQuestions.vue?vue&type=template&id=fd8d81b8&scoped=true"
import script from "./PersonalizedQuestions.vue?vue&type=script&lang=js"
export * from "./PersonalizedQuestions.vue?vue&type=script&lang=js"
import style0 from "./PersonalizedQuestions.vue?vue&type=style&index=0&id=fd8d81b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8d81b8",
  null
  
)

export default component.exports